import {required,numeric} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrProsesTablo = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrProsesTabloData:{
            Ustid: null,
            Prosesid: "",
            Tabloadi: "",
            Seviye: 0,
            Sirano: "",
            Deleted: false,
          },
        FormDataType:{ 
          Sirano:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('StrProsesTablo.AddEdit.Sirano'),FieldType:"text"},
          Tabloadi:{FieldName:"Tabloadi",Field:"input",FieldTitle:this.$t('StrProsesTablo.AddEdit.Tabloadi'),FieldType:"text"}, 
        }   
      }
    },
    validations:{ 
        FormData: {
            Ustid: {},
            Prosesid: { required },   
            Tabloadi: {},
            Seviye:{required,numeric},
            Sirano:{required},
        } 
    },


    created(){ 


    
      
    }

}
export default StrProsesTablo